export default __webpack_public_path__ + "static/media/blackPhone.432dd8b5.jpg";